import { Component, h, Host, State } from '@stencil/core';
import state from '@ugc-store';

import { Guarantee } from '../../icons/index';

@Component({
  tag: 'ugc-authentic-banner',
  shadow: false,
})
export class UgcAuthenticBanner {
  @State() isExpanded: boolean = false;

  handleToggle = () => {
    this.isExpanded = !this.isExpanded;
  };
  render() {
    const {
      reviewStaticLanguage: {
        IDS_PRODUCT_AUTHENTICITY = '',
        IDS_UGC_AUTHORIZED_DISTRIBUTORS = '',
        IDS_UGC_AUTHORIZED_DISTRIBUTORS_INFO = '',
        IDS_MSG_SHOW_MORE = '',
        IDS_MSG_SHOW_LESS = '',
      } = {},
    } = state;
    return (
      <Host>
        <div
          class="flex-row-start-start gap-4 p-16 rounded-16 mb-16 authentic-wrapper"
          style={{
            backgroundColor: '#e5f8e6',
          }}
        >
          <div style={{ flexShrink: '0' }}>
            <Guarantee />
          </div>
          <div class="flex-col-start-start gap-2">
            <span class="fs-16 lh-24 bold">{IDS_PRODUCT_AUTHENTICITY}</span>
            <p class="fs-16 lh-24">
              <span id="expanded-content">
                {this.isExpanded ? IDS_UGC_AUTHORIZED_DISTRIBUTORS_INFO : IDS_UGC_AUTHORIZED_DISTRIBUTORS}
              </span>{' '}
              &nbsp;
              <button
                class="color-blue-dark pointer"
                style={{
                  border: 'none',
                  background: 'none',
                }}
                onClick={() => {
                  this.handleToggle();
                }}
                type="button"
              >
                {this.isExpanded ? IDS_MSG_SHOW_LESS : IDS_MSG_SHOW_MORE}
              </button>
            </p>
          </div>
        </div>
      </Host>
    );
  }
}
